import {
    setCookie,
    getCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    aosConfig,
    addScollClass,
    addParalax,
    addFancyboxFixForGallery,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService
} from './functions';


import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

const gsapAnimIMage = (imageHolder) => {
    const image = imageHolder.querySelector(':scope img');
    gsap.fromTo(image, {
        y: imageHolder.offsetHeight - image.offsetHeight,
        ease: 'power2.inOut',
        duration: 4
    }, {
        scrollTrigger: {
            trigger: imageHolder,
            start: "top 95%",
            end: "bottom 10%",
            scrub: true,
            // markers: true,
            // once: true
        },
        y: 0,
        ease: 'power2.inOut'
    });
}

const mainApp = () => {


    if (getCookie('introAnim') == 1) {
        $('.intro').addClass('hide');
        $('.intro').removeClass('show');
        $('body').removeClass('showMenu');
        //  $('.intro').css('visibility', 'hidden');

    } else {
        $('.intro').addClass('hide2');
        $('.intro').removeClass('show');
        $('body').removeClass('showMenu');
        //$('.intro').css('visibility', 'hidden');

    }

    window.onpageshow = function (event) {
        if (event.persisted) {
            $('.intro').removeClass('show');
            $('body').removeClass('showMenu');
        }

    };

    setCookie('introAnim', 0);



    $('a[href*="' + location.host + '"]:not([href$=".jpg"]):not([href$=".jpeg"]):not([href$=".png"]):not([href$=".gif"]):not([href$=".pdf"]):not([href$=".txt"]):not([href$=".doc"]):not([href$=".docx"]):not([href$=".odt"]):not([href$=".odf"]):not([target="_blank"])')
        .click(function (e) {
            if (!e.ctrlKey) {
                $('.intro').removeClass('hide2');
                $('.intro').css('visibility', 'visible');
                $('.intro').addClass('show');

                setCookie('introAnim', 1);

            }
        });



    const animUp = document.querySelectorAll('.indexC1 .wp-block-group, .indexC1 .specialMainImages, .indexC2__content, .indexC4__content, .indexC4__content2');

    [...animUp].forEach(item => {
        gsap.from(item, {
            y: '30px',
            opacity: 0,
            duration: 1,
            scrollTrigger: {
                trigger: item,
                start: "top 70%",
                // end: "bottom 10%",
                toggleActions: 'play play play play',
                // markers: true,
                //once: true
            }
        });
    });

    const imgeList = document.querySelectorAll('.spIHolder');

    if (imgeList.length > 0) {
        [...imgeList].forEach((imageHolder) => gsapAnimIMage(imageHolder));
    }


    gsap.utils.toArray('.indexC2__list').forEach((line, i) => {
        const links = line.querySelectorAll("div"),
            tl = horizontalLoop(links, {
                repeat: -1,
                speed: 0.7,
                reversed: i ? true : false,
                paddingRight: parseFloat(gsap.getProperty(links[0], "marginRight", "px")) // otherwise first element would be right up against the last when it loops. In this layout, the spacing is done with marginRight.
            });
        links.forEach(link => {
            link.addEventListener("mouseenter", () => gsap.to(tl, { timeScale: 0, overwrite: true }));
            link.addEventListener("mouseleave", () => gsap.to(tl, { timeScale: i ? -1 : 1, overwrite: true }));
        });
    });

    gsap.utils.toArray('.indexC2__list2').forEach((line, i) => {

        const links = line.querySelectorAll("div"),
            tl = horizontalLoop(links, {
                repeat: -1,
                speed: 0.7,
                reversed: i ? false : true,
                paddingRight: parseFloat(gsap.getProperty(links[0], "marginRight", "px")) // otherwise first element would be right up against the last when it loops. In this layout, the spacing is done with marginRight.
            });
        links.forEach(link => {
            link.addEventListener("mouseenter", () => gsap.to(tl, { timeScale: 0, overwrite: true }));
            link.addEventListener("mouseleave", () => gsap.to(tl, { timeScale: i ? 1 : -1, overwrite: true }));
        });
    });



    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    aosConfig();

    // add scroll class to body  
    addScollClass('0px', 'scroll');

    // add paralax to element
    addParalax('.paralax');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.blocks-gallery-grid');

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();


}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.indexHeader__movieTrigger').click(function () {
            document.querySelector('.indexHeader').classList.toggle('showMovie');
        });

        $('.indexHeader__scrollDown').click(function () {
            $('html,body').animate({ scrollTop: ($(this).offset().top - 50) + 'px' }, 500);
        });



        //rotator and sliders
        if ($('.indexC3__slider').length > 0) {
            const footerSliderCount = $('.indexC3__slider .pageBox ').length;
            gsap.to('.indexC3__sliderBarHendle', {
                scaleX: 1 / footerSliderCount,
                duration: 0.3
            });
            // $('.indexC3__sliderBarCountAll').html(footerSliderCount);
            $('.indexC3__slider').slick({
                infinite: false,
                arrows: true,
                dots: false,
                autoplay: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 5000,
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
            $('.indexC3__slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                const slide = nextSlide + (window.innerWidth >= 768 ? 2 : 1);

                //  $('.indexC3__sliderBarCountCurrent').html(slide);

                gsap.to('.indexC3__sliderBarHendle', {
                    scaleX: slide / footerSliderCount,
                    duration: 0.3
                });
            });

        }
        if ($('.clientList').length > 0) {
            $('.clientList').slick({
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                variableWidth: true,
                centerMode: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                speed: 2000,
                autoplaySpeed: 0,
                pauseOnHover: true,
                cssEase: 'linear'
            });

        }




        //fancybox
        $(".blocks-gallery-item a, .fancybox, .wp-block-image a").fancybox({
            'loop': true,
            'margin': [44, 0],
            'gutter': 50,
            'keyboard': true,
            'arrows': true,
            'infobar': false,
            'toolbar': true,
            'buttons': ["slideShow", "fullScreen", "close"],
            'idleTime': 4,
            'protect': false,
            'modal': false,
            'animationEffect': "fade",
            'animationDuration': 600,
            'transitionEffect': "fade",
            'transitionDuration': 800,
            backFocus: false,
            thumbs: {
                autoStart: true, // Display thumbnails on opening
                hideOnClose: true, // Hide thumbnail grid when closing animation starts
                parentEl: ".fancybox-container", // Container is injected into this element
                axis: "y" // Vertical (y) or horizontal (x) scrolling
            }
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



/*
This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.

Features:
 - Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
 - When each item animates to the left or right enough, it will loop back to the other side
 - Optionally pass in a config object with values like "speed" (default: 1, which travels at roughly 100 pixels per second), paused (boolean),  repeat, reversed, and paddingRight.
 - The returned timeline will have the following methods added to it:
   - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
   - current() - returns the current index (if an animation is in-progress, it reflects the final index)
   - times - an Array of the times on the timeline where each element hits the "starting" spot. There's also a label added accordingly, so "label1" is when the 2nd element reaches the start.
 */
function horizontalLoop(items, config) {
    items = gsap.utils.toArray(items);
    config = config || {};
    let tl = gsap.timeline({ repeat: config.repeat, paused: config.paused, defaults: { ease: "none" }, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100) }),
        length = items.length,
        startX = items[0].offsetLeft,
        times = [],
        widths = [],
        xPercents = [],
        curIndex = 0,
        pixelsPerSecond = (config.speed || 1) * 100,
        snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
        totalWidth, curX, distanceToStart, distanceToLoop, item, i;
    gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
        xPercent: (i, el) => {
            let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
            xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
            return xPercents[i];
        }
    });
    gsap.set(items, { x: 0 });
    totalWidth = items[length - 1].offsetLeft + xPercents[length - 1] / 100 * widths[length - 1] - startX + items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], "scaleX") + (parseFloat(config.paddingRight) || 0);
    for (i = 0; i < length; i++) {
        item = items[i];
        curX = xPercents[i] / 100 * widths[i];
        distanceToStart = item.offsetLeft + curX - startX;
        distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
        tl.to(item, { xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond }, 0)
            .fromTo(item, { xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100) }, { xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false }, distanceToLoop / pixelsPerSecond)
            .add("label" + i, distanceToStart / pixelsPerSecond);
        times[i] = distanceToStart / pixelsPerSecond;
    }
    function toIndex(index, vars) {
        vars = vars || {};
        (Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
        let newIndex = gsap.utils.wrap(0, length, index),
            time = times[newIndex];
        if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
            vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
            time += tl.duration() * (index > curIndex ? 1 : -1);
        }
        curIndex = newIndex;
        vars.overwrite = true;
        return tl.tweenTo(time, vars);
    }
    tl.next = vars => toIndex(curIndex + 1, vars);
    tl.previous = vars => toIndex(curIndex - 1, vars);
    tl.current = () => curIndex;
    tl.toIndex = (index, vars) => toIndex(index, vars);
    tl.times = times;
    if (config.reversed) {
        tl.vars.onReverseComplete();
        tl.reverse();
    }
    return tl;
}